var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":'tel:' + _vm.number}},[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" "+_vm._s(_vm.number)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }